// extracted by mini-css-extract-plugin
export default {"cc-education-bar":"ghguIugX","cc-education-bar-wrap":"YGGHR0rL","cc-education-bar-nav":"cpq6_e8a","js-selected":"C3w0VG88"};